var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{attrs:{"id":"the-header"}},[_c('div',{staticClass:"container"},[_c('h1',{domProps:{"textContent":_vm._s(_vm.getHeadingText)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }